<template>
  <CardToggle
    :label="$t('global.core-upgrades')"
    :description="$t('global.core-upgrades-disable-warning')"
    class="pb-4"
  >
    <template #toggle>
      <Toggle
        :value="enabled"
        @change="onToggle"
        :transitioning="isProcessing()"
        :disabled="!isLoaded()"
      />
    </template>
  </CardToggle>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import CardToggle from "@/components/display/card-sub-components/CardToggle";
import store from "@/store";
import Toggle from "@/components/display/Toggle";

export default {
  name: "CoreUpgrades",
  components: {
    CardToggle,
    Toggle,
  },
  props: {
    resourceName: {
      type: String,
      required: true,
    },
    site: Object,
  },
  setup(props, { root }) {
    const enabled = computed(() => store.getters["wpWoo/getCoreSettings"]?.enabled || false);
    const status = computed(() => store.getters["wpWoo/getCoreSettingsStatus"]);
    const isUpdating = computed(() =>
      store.getters["wpWoo/areCoreSettingsUpdating"](props.site.id)
    );
    const isSubmitting = ref(false);

    const isLoaded = () => status.value.isLoaded;
    const isProcessing = () => status.value.isUpdating || isUpdating.value || isSubmitting.value;

    const onToggle = (enabled) => {
      isSubmitting.value = true;
      store
        .dispatch("wpWoo/updateCoreSettings", {
          id: props.site.id,
          data: { enable: enabled },
        })
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.core-updates-changing-message", {
              name: props.resourceName,
              action: root.$t(enabled ? "global.enabled" : "global.disabled").toLowerCase(),
            }),
          });
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.core-updates-change-error-message", {
              name: props.resourceName,
              action: root.$t(enabled ? "global.enable" : "global.disable").toLowerCase(),
            }),
          });
        })
        .finally(() => (isSubmitting.value = false));
    };

    onMounted(() => {
      store.dispatch("wpWoo/getCoreSettings", props.site.id);
    });

    return {
      enabled,
      isLoaded,
      isProcessing,
      onToggle,
    };
  },
};
</script>
